<template>
    <a-modal title="编辑专项表单" :maskClosable="false" @cancel="reset" v-model="isShow" wrapClassName="manage_modal table_manage_model">
        <a-alert message="若配置未指定唯一索引，无法修改表单" banner />
        <a-form :form="form" ref="form">
            <a-form-item :label="title" :label-col="{span: 5}" :wrapper-col="{span: 12}"> 
              <a-input style="width:300px" v-decorator="[field.id, {initialValue:data[field.id], rules: [{ required: true, message: '必填项' }]}]"/>
            </a-form-item>
        </a-form>
        <template slot="footer">
            <a-button key="submit" type="primary" @click="submit">应用</a-button>
            <a-button key="cancel" @click="reset">取消</a-button>
        </template>
    </a-modal>
</template>

<script>
import Vue from 'vue'
export default {
    props: ['show', 'data', 'field', 'id', 'name'],
    model: {
        prop: 'show',
        event: 'close'
    },
    watch: {
        data() {
            this.initData()
            this.form.resetFields()
        },
        show() {
            this.isShow=this.show
        },
        field() {
            this.initData()
        }
    },
    mounted() {
        this.initData()
    },
    data() {
        return {
            form: this.$form.createForm(this),
            isShow: false,
            title: null
        }
    },
    methods: {
        initData(){
            this.title = this.field.title
        },
        submit() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    let params = {
                      id_key: this.id,
                      id_value: this.data[this.id],
                      edit_key: this.field.id,
                      edit_value: values[this.field.id],
                      name: this.name
                    }
                    this.$service.patchData(`${this.$service.api.manage.table}`, params).then((data)=>{
                        this.$message.success('编辑成功')
                        this.$emit("reload", params.edit_value)
                        this.reset()
                    })
                }
            });
        },
        reset(){
            this.form.resetFields()
            this.$emit("close", false)
        }
  },
}
</script>
<style lang="less">
.table_manage_model {
    margin-top: 10%;
    .ant-form-item-control {
        width:300px;
    }
    .is_all_item {
        .ant-form-item-label label:after {
            content: ' '
        }
    }
    .ant-calendar-picker-input {
        width:300px;
    }
    .ant-calendar-range-picker-input {
        // width: 80px;
        text-align: left;
    }
    .ant-calendar-range-picker-separator {
        margin:0 10px 0 0;
    }
}
</style>